var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"front-wrapper"},[_c('Header'),_vm._v(" "),_c('div',{staticClass:"frontend-main d-flex"},[_c('Preloader'),_vm._v(" "),_c('router-view')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }